import type { IExercise } from '../exercises';

export const ARCHIVED_CHEST_TEACHINGS: IExercise[] = [
  {
    "id": "barbell-flat-press",
    "name": "杠铃平板卧推",
    "bodyPart": "chest",
    "equipment": "barbell",
    "subCategory": "mid-chest",
    "tips": ["核心收紧，控制动作节奏","全程保持肩胛骨稳定"],
    "sets": 4,
    "reps": "8-12",
    "rpe": 8,
    "restSeconds": 90,
    "isBodyweight": false,
    "difficulty": "advanced",
    "targetMuscles": ["胸大肌","三角肌前束"],
    "demoUrl": "/media/gifs/barbell-flat-press",
    "videoUrl": "/media/videos/barbell-flat-press",
  },
  {
    "id": "cable-crossover",
    "name": "龙门架绳索夹胸",
    "bodyPart": "chest",
    "equipment": "cable",
    "subCategory": "inner-chest",
    "tips": ["核心收紧，控制动作节奏","全程保持肩胛骨稳定"],
    "sets": 3,
    "reps": "12-15",
    "rpe": 8,
    "restSeconds": 60,
    "isBodyweight": false,
    "difficulty": "advanced",
    "targetMuscles": ["胸大肌中缝","前锯肌"],
    "demoUrl": "/media/gifs/cable-crossover",
    "videoUrl": "/media/videos/cable-crossover",
  },
  {
    "id": "push-up",
    "name": "俯卧撑",
    "bodyPart": "chest",
    "equipment": "bodyweight",
    "subCategory": "mid-chest",
    "tips": ["核心收紧，控制动作节奏","全程保持肩胛骨稳定"],
    "sets": 3,
    "reps": "力竭",
    "rpe": 9,
    "restSeconds": 60,
    "isBodyweight": true,
    "difficulty": "advanced",
    "targetMuscles": ["胸大肌","三角肌前束"],
    "demoUrl": "/media/gifs/push-up",
    "videoUrl": "/media/videos/push-up",
  },
  {
    "id": "home-dumbbell-pushup",
    "name": "哑铃俯卧撑",
    "bodyPart": "chest",
    "equipment": "dumbbell",
    "subCategory": "mid-chest",
    "tips": ["核心收紧，控制动作节奏","全程保持肩胛骨稳定"],
    "sets": 4,
    "reps": "力竭",
    "rpe": 9,
    "restSeconds": 75,
    "isBodyweight": false,
    "difficulty": "advanced",
    "targetMuscles": ["胸大肌","三角肌前束"],
    "demoUrl": "/media/gifs/home-dumbbell-pushup",
    "videoUrl": "/media/videos/home-dumbbell-pushup",
  },
  {
    "id": "home-dumbbell-flat-press",
    "name": "哑铃平板卧推",
    "bodyPart": "chest",
    "equipment": "dumbbell",
    "subCategory": "mid-chest",
    "tips": ["核心收紧，控制动作节奏","全程保持肩胛骨稳定"],
    "sets": 4,
    "reps": "8-12",
    "rpe": 8,
    "restSeconds": 75,
    "isBodyweight": false,
    "difficulty": "advanced",
    "targetMuscles": ["胸大肌","三角肌前束"],
    "demoUrl": "/media/gifs/home-dumbbell-flat-press",
    "videoUrl": "/media/videos/home-dumbbell-flat-press",
  },
  {
    "id": "home-dumbbell-fly",
    "name": "哑铃飞鸟",
    "bodyPart": "chest",
    "equipment": "dumbbell",
    "subCategory": "inner-chest",
    "tips": ["核心收紧，控制动作节奏","全程保持肩胛骨稳定"],
    "sets": 3,
    "reps": "12-15",
    "rpe": 8,
    "restSeconds": 60,
    "isBodyweight": false,
    "difficulty": "advanced",
    "targetMuscles": ["胸大肌中缝","前锯肌"],
    "demoUrl": "/media/gifs/home-dumbbell-fly",
    "videoUrl": "/media/videos/home-dumbbell-fly",
  },
  {
    "id": "home-band-chest-activate",
    "name": "弹力带胸部激活",
    "bodyPart": "chest",
    "equipment": "resistance-band",
    "subCategory": "chest",
    "tips": ["核心收紧，控制动作节奏","全程保持稳定"],
    "sets": 2,
    "reps": "15",
    "rpe": 4,
    "restSeconds": 30,
    "isBodyweight": false,
    "isWarmup": true,
    "difficulty": "beginner",
    "targetMuscles": ["全身激活肌群"],
    "demoUrl": "/media/gifs/home-band-chest-activate",
    "videoUrl": "/media/videos/home-band-chest-activate",
  },
  {
    "id": "ksw-chest-bench-press-compressed",
    "name": "杠铃卧推(compressed版)",
    "bodyPart": "chest",
    "equipment": "barbell",
    "subCategory": "mid-chest",
    "tips": ["脚踩稳地面，核心收紧","下放至胸中部，推起时不锁死肘关节"],
    "sets": 4,
    "reps": "5",
    "rpe": 9,
    "restSeconds": 120,
    "isBodyweight": false,
    "difficulty": "advanced",
    "targetMuscles": ["胸大肌","三角肌前束"],
    "source": "凯圣王合集",
    "demoUrl": "/media/gifs/ksw-chest-bench-press-compressed",
    "videoUrl": "/media/videos/ksw-chest-bench-press-compressed",
  },
  {
    "id": "ksw-dips",
    "name": "双杠臂屈伸",
    "bodyPart": "chest",
    "equipment": "bodyweight",
    "subCategory": "lower-chest",
    "tips": ["身体前倾重心前移，侧重下胸","下放至大臂平行于地面或略低"],
    "sets": 3,
    "reps": "12-15",
    "rpe": 8,
    "restSeconds": 90,
    "isBodyweight": true,
    "difficulty": "advanced",
    "targetMuscles": ["下胸肌","胸大肌"],
    "source": "凯圣王合集",
    "demoUrl": "/media/gifs/ksw-dips",
    "videoUrl": "/media/videos/ksw-dips",
  },
  {
    "id": "ksw-warmup-pec-minor-release",
    "name": "胸小肌放松",
    "bodyPart": "chest",
    "equipment": "foam-roller",
    "subCategory": "放松",
    "tips": ["泡沫轴放胸小肌处，缓慢滚动找酸痛点停留呼吸","每侧各做 1-2 分钟"],
    "sets": 1,
    "reps": "1-2分钟",
    "rpe": 2,
    "restSeconds": 0,
    "isBodyweight": false,
    "isWarmup": true,
    "difficulty": "beginner",
    "targetMuscles": ["全身激活肌群"],
    "source": "凯圣王合集",
    "demoUrl": "/media/gifs/ksw-warmup-pec-minor-release",
    "videoUrl": "/media/videos/ksw-warmup-pec-minor-release",
  },
  {
    "id": "ksw-warmup-pec-major-release",
    "name": "胸大肌放松",
    "bodyPart": "chest",
    "equipment": "foam-roller",
    "subCategory": "放松",
    "tips": ["侧卧，泡沫轴放胸大肌位置滚动","找到紧张点停留 20-30 秒"],
    "sets": 1,
    "reps": "1-2分钟",
    "rpe": 2,
    "restSeconds": 0,
    "isBodyweight": false,
    "isWarmup": true,
    "difficulty": "beginner",
    "targetMuscles": ["全身激活肌群"],
    "source": "凯圣王合集",
    "demoUrl": "/media/gifs/ksw-warmup-pec-major-release",
    "videoUrl": "/media/videos/ksw-warmup-pec-major-release",
  },
  {
    "id": "ksw-warmup-serratus-activation",
    "name": "前锯肌激活",
    "bodyPart": "chest",
    "equipment": "bodyweight",
    "subCategory": "激活",
    "tips": ["俯卧撑位，肩胛骨前引再收回","感受前锯肌发力，核心稳定不塌腰"],
    "sets": 2,
    "reps": "15",
    "rpe": 3,
    "restSeconds": 30,
    "isBodyweight": true,
    "isWarmup": true,
    "difficulty": "beginner",
    "targetMuscles": ["全身激活肌群"],
    "source": "凯圣王合集",
    "demoUrl": "/media/gifs/ksw-warmup-serratus-activation",
    "videoUrl": "/media/videos/ksw-warmup-serratus-activation",
  },
  {
    "id": "threeway-machine-fly",
    "name": "坐姿夹胸",
    "bodyPart": "chest",
    "equipment": "machine",
    "subCategory": "mid-chest",
    "tips": ["顶峰收缩1秒","控制回放速度"],
    "sets": 3,
    "reps": "12-15",
    "rpe": 8,
    "restSeconds": 60,
    "isBodyweight": false,
    "demoUrl": "/media/videos/threeway-machine-fly",
    "videoUrl": "/media/videos/threeway-machine-fly",
  },
  {
    "id": "threeway-flat-machine-press",
    "name": "平板器械卧推",
    "bodyPart": "chest",
    "equipment": "machine",
    "subCategory": "mid-chest",
    "tips": ["肩胛骨收紧下沉","推到顶端不锁肘"],
    "sets": 3,
    "reps": "12-15",
    "rpe": 8,
    "restSeconds": 75,
    "isBodyweight": false,
    "demoUrl": "/media/videos/threeway-flat-machine-press",
    "videoUrl": "/media/videos/threeway-flat-machine-press",
  },
  {
    "id": "threeway-dips",
    "name": "双杠臂屈伸",
    "bodyPart": "chest",
    "equipment": "bodyweight",
    "subCategory": "lower-chest",
    "tips": ["身体前倾刺激下胸","下放至大臂平行"],
    "sets": 3,
    "reps": "12-15",
    "rpe": 8,
    "restSeconds": 60,
    "isBodyweight": true,
    "demoUrl": "/media/videos/threeway-dips",
    "videoUrl": "/media/videos/threeway-dips",
  },
  {
    "id": "threeway-decline-cable-fly",
    "name": "绳索夹下胸",
    "bodyPart": "chest",
    "equipment": "cable",
    "subCategory": "lower-chest",
    "tips": ["从高往低夹","顶峰收缩挤压下胸"],
    "sets": 3,
    "reps": "12-15",
    "rpe": 8,
    "restSeconds": 60,
    "isBodyweight": false,
    "demoUrl": "/media/videos/threeway-decline-cable-fly",
    "videoUrl": "/media/videos/threeway-decline-cable-fly",
  },
  {
    "id": "personal-s1-chest-stretch",
    "name": "胸大肌拉伸",
    "bodyPart": "chest",
    "equipment": "bodyweight",
    "subCategory": "chest",
    "tips": ["保持挺胸，感受胸肌拉伸","每侧保持30-60秒"],
    "sets": 2,
    "reps": "45秒",
    "rpe": 2,
    "restSeconds": 10,
    "isBodyweight": true,
    "isStretch": true,
    "isWarmup": true,
    "source": "私教版",
    "demoUrl": "/media/gifs/personal-s1-chest-stretch",
    "videoUrl": "/media/videos/personal-s1-chest-stretch",
  },
  {
    "id": "personal-s4-seated-flat-press",
    "name": "坐姿平推",
    "bodyPart": "chest",
    "equipment": "machine",
    "subCategory": "mid-chest",
    "tips": ["挺胸沉肩肩胛后收","推至胸口正上方"],
    "sets": 3,
    "reps": "10",
    "rpe": 8,
    "restSeconds": 75,
    "isBodyweight": false,
    "source": "私教版",
    "demoUrl": "/media/gifs/personal-s4-seated-flat-press",
    "videoUrl": "/media/videos/personal-s4-seated-flat-press",
  },
  {
    "id": "personal-s4-cable-upper-chest",
    "name": "绳索夹上胸",
    "bodyPart": "chest",
    "equipment": "cable",
    "subCategory": "upper-chest",
    "tips": ["由下往上夹胸","顶峰收缩停顿1秒"],
    "sets": 3,
    "reps": "15",
    "rpe": 7,
    "restSeconds": 60,
    "isBodyweight": false,
    "source": "私教版",
    "demoUrl": "/media/gifs/personal-s4-cable-upper-chest",
    "videoUrl": "/media/videos/personal-s4-cable-upper-chest",
  },
  {
    "id": "fanjue-standing-chest-shoulder-stretch",
    "name": "站立肩胸拉伸",
    "bodyPart": "chest",
    "equipment": "bodyweight",
    "subCategory": "chest",
    "tips": ["感受胸肩前侧拉伸","每侧30秒"],
    "sets": 2,
    "reps": "15次",
    "rpe": 4,
    "restSeconds": 30,
    "isBodyweight": true,
    "isWarmup": true,
    "demoUrl": "/media/gifs/fanjue-standing-chest-shoulder-stretch",
    "videoUrl": "/media/videos/fanjue-standing-chest-shoulder-stretch",
  },
  {
    "id": "fanjue-incline-barbell-press",
    "name": "上斜卧推",
    "bodyPart": "chest",
    "equipment": "barbell",
    "subCategory": "upper-chest",
    "tips": ["上斜30度","杠铃下放至胸上沿"],
    "sets": 3,
    "reps": "12-15",
    "rpe": 8,
    "restSeconds": 75,
    "isBodyweight": false,
    "demoUrl": "/media/gifs/fanjue-incline-barbell-press",
    "videoUrl": "/media/videos/fanjue-incline-barbell-press",
  },
  {
    "id": "fanjue-chest-warmup",
    "name": "胸部热身",
    "bodyPart": "chest",
    "equipment": "bodyweight",
    "subCategory": "chest",
    "tips": ["胸部肌群动态激活","俯卧撑变体"],
    "sets": 2,
    "reps": "15次",
    "rpe": 5,
    "restSeconds": 30,
    "isBodyweight": true,
    "isWarmup": true,
    "demoUrl": "/media/gifs/fanjue-chest-warmup",
    "videoUrl": "/media/videos/fanjue-chest-warmup",
  },
  {
    "id": "fanjue-incline-smith-press",
    "name": "上斜史密斯",
    "bodyPart": "chest",
    "equipment": "machine",
    "subCategory": "upper-chest",
    "tips": ["史密斯轨迹稳定","侧重上胸"],
    "sets": 3,
    "reps": "12-15",
    "rpe": 8,
    "restSeconds": 75,
    "isBodyweight": false,
    "demoUrl": "/media/gifs/fanjue-incline-smith-press",
    "videoUrl": "/media/videos/fanjue-incline-smith-press",
  },
  {
    "id": "fanjue-incline-machine-chest-press",
    "name": "上斜推胸",
    "bodyPart": "chest",
    "equipment": "machine",
    "subCategory": "upper-chest",
    "tips": ["器械上斜推胸","顶峰收缩"],
    "sets": 3,
    "reps": "12-15",
    "rpe": 8,
    "restSeconds": 75,
    "isBodyweight": false,
    "demoUrl": "/media/gifs/fanjue-incline-machine-chest-press",
    "videoUrl": "/media/videos/fanjue-incline-machine-chest-press",
  },
];
